import { render, staticRenderFns } from "./UpdateStatusImportant.vue?vue&type=template&id=af470f4a&"
import script from "./UpdateStatusImportant.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusImportant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports